// eslint-disable-next-line no-use-before-define
import React, { useState } from 'react';
import { View, Text, TouchableWithoutFeedback, ImageBackground, Dimensions } from 'react-native';
import Image from '@kds/image';
import { $k18n } from '@/common/i18n';

import pupupClose from '@/assets/images/pupup_close.png';
import couponBgRedv1 from '@/assets/images/coupon-bg-red-v2.png';
import couponBgBluev1 from '@/assets/images/coupon-bg-blue-v2.png';
import couponTitleBgv1 from '@/assets/images/coupon-title-bg-v1.png';
import couponUncheckRaido from '@/assets/images/unchecked_next_time.png';
import couponCheckRaido from '@/assets/images/checked_next_time.png';
import { CountDownV2 } from '@kibt/meta-ui-krn';
import { scaleW } from '@/common/style';
import { useDetailPageStore } from '@/page/detail/store';
import { Swiper } from '@kibt/meta-ui-krn';
import './index.css';
import { isAndroid, isMobileDeviceValue, isSmallDeviceWidth } from '@/common/device-info';
import { useLoginStore } from '@/component/LoginSdk/store/useLoginStore';
import { checkIfPopupByTime, checkIfPopupInOneDay, setRemindMeLaterConfig } from './localstorage';

const isNotUndefind = val => typeof val !== 'undefined';

const padding = (top, right?, bottom?, left?) => {
    return {
        paddingTop: top,
        paddingRight: isNotUndefind(right) ? right : top,
        paddingBottom: isNotUndefind(bottom) ? bottom : top,
        paddingLeft: isNotUndefind(left) ? left : isNotUndefind(right) ? right : top,
    };
};

function vh(percentage) {
    const viewportHeight = Dimensions.get('screen').height;
    const decimal = percentage * 0.01;
    percentage = parseInt(percentage, 10);

    // Hard limits
    if (percentage < 0) {
        percentage = 100;
    }
    if (percentage > 1000) {
        percentage = 1000;
    }

    return Math.round(viewportHeight * decimal);
}

let remindLaterFlagOriginal = false;

export function CouponHomePop() {
    const { dialogData } = useDetailPageStore(s => ({
        dialogData: s?.couponData?.popup,
    }));
    const [show, setShow] = useState(true);
    const [remindLaterFlag, setRemindLater] = useState(remindLaterFlagOriginal);
    const { setLoginModelVisible, isLogin } = useLoginStore(s => ({
        setLoginModelVisible: s.setLoginModelVisible,
        isLogin: s.isLogin,
    }));

    const getTitleText = coupon => {
        if (coupon.discountFeeType === 3) {
            if (coupon?.displayDeductionAmount || coupon?.displayMaxDeductAmount) {
                return $k18n({ id: 'k_1225781', params: { num: coupon?.displayDeductionAmount || coupon?.displayMaxDeductAmount } });
            } else {
                return $k18n({ text: '包邮', id: 'free_shipping_upper' });
            }
        }
        // 折扣券
        if (coupon.discountFeeType === 2 && coupon.discountType === 3) {
            return $k18n({ text: '{0}% off', id: 'k_1221298', params: { 0: coupon.displayDiscountPercent } });
        }
        return $k18n({ text: '{discount} OFF', params: { discount: coupon.displayMaxDeductAmount } });
    };

    const renderCouponTitle = (coupon, itemStyle, themeColor, type) => {
        if (coupon.discountFeeType === 3) {
            if (coupon?.displayDeductionAmount || coupon?.displayMaxDeductAmount) {
                return (
                    <View
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            paddingTop: type === 'large' ? 21 : 15,
                            // justifyContent: 'center',
                            height: scaleW(itemStyle.conponContentHeight),
                        }}>
                        <Text
                            style={{
                                color: themeColor,
                                fontSize: itemStyle.conponContentFontSize,
                                fontWeight: '700',
                            }}>
                            -{coupon?.displayDeductionAmount || coupon?.displayMaxDeductAmount}
                        </Text>
                        <Text
                            style={{
                                color: themeColor,
                                fontSize: 10,
                                fontWeight: '700',
                            }}>
                            no Frete
                        </Text>
                    </View>
                );
            }
        }

        if (coupon.discountFeeType === 2 && coupon.discountType === 3) {
            return (
                <View
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        paddingTop: type === 'large' ? 21 : 15,
                        height: scaleW(itemStyle.conponContentHeight),
                    }}>
                    <Text
                        style={{
                            color: themeColor,
                            fontSize: itemStyle.conponContentFontSize,
                            fontWeight: '700',
                        }}>
                        {getTitleText(coupon)}
                    </Text>
                </View>
            );
        }

        return (
            <View
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    paddingTop: type === 'large' ? 21 : 15,
                    // justifyContent: 'center',
                    height: scaleW(itemStyle.conponContentHeight),
                }}>
                <Text
                    style={{
                        color: themeColor,
                        fontSize: itemStyle.conponContentFontSize,
                        fontWeight: '700',
                    }}>
                    -{coupon.displayMaxDeductAmount}
                </Text>
            </View>
        );
    };

    const getDescText = coupon => {
        if (coupon.threshold) {
            return $k18n({ id: 'k_322825', params: { min_spend: coupon.displayThreshold } });
        }
        return $k18n({ id: 'k_322811', text: '无门槛' });
    };

    const onClickCloseBtn = () => {
        if (remindLaterFlag) {
            setRemindMeLaterConfig();
        }
        setShow(false);
    };

    const showLoginPop = () => {
        setLoginModelVisible(true);
    };

    if (!dialogData || !dialogData?.couponListView?.length || !show) {
        return null;
    }

    // 用户设置了超过 7 天不弹窗
    if (!checkIfPopupByTime()) {
        return null;
    }

    // 频控，未登录，一天至多弹一次
    if (!isLogin && !checkIfPopupInOneDay()) {
        return null;
    }

    const getTitleFontSize = length => {
        if (length > 0 && length < 28) {
            return 32;
            // 2
        }
        if (length > 27) {
            return 22;
            // 2
        }
        return 22;
    };

    const couponDialogTitle = () => {
        return (
            <ImageBackground
                source={couponTitleBgv1} // 宽高比 1.9/1
                resizeMode="contain"
                style={[
                    {
                        width: scaleW(377),
                        height: scaleW(200),
                        position: 'relative',
                        top: dialogData?.couponListView?.length > 6 ? 14 : 0,
                    },
                ]}>
                <View
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        paddingLeft: 63,
                        paddingRight: 63,
                        height: isMobileDeviceValue ? scaleW(144) : scaleW(150),
                    }}>
                    <Text
                        numberOfLines={4}
                        ellipsizeMode={'tail'}
                        style={{
                            color: '#FFFFFF',
                            fontSize: getTitleFontSize(dialogData?.popupInfoMaterial?.common?.title?.length),
                            fontWeight: '900',
                            textAlign: 'center',
                        }}>
                        {dialogData?.moduleTitle || 'Parabéns por obter o cupom de novato'}
                    </Text>
                </View>
                <View
                    style={{
                        position: 'absolute',
                        bottom: isMobileDeviceValue ? 28 : 24,
                        width: '100%',
                    }}>
                    <View
                        style={{"display":"flex","flexDirection":"row","justifyContent":"center"}}>
                        {dialogData?.countDownInfoView?.countDownTime ? (
                            <CountDownV2 leftTime={dialogData?.countDownInfoView?.countDownTime ?? 0} format="HH:mm:ss">
                                {({ formatteRes }) => (
                                    <Text
                                        style={{"color":"#FFFFFF","fontSize":"3.381642512077295rem","fontWeight":"900"}}>
                                        {formatteRes.days > 0
                                            ? $k18n({ id: 'k_408332', text: '有效期还剩' }) +
                                              ' ' +
                                              $k18n({
                                                  id: 'k_408333',
                                                  text: '{0}天',
                                                  params: { 0: formatteRes.days },
                                              })
                                            : $k18n({ id: 'k_408332', text: '有效期还剩' }) + ' ' + formatteRes.formated}
                                    </Text>
                                )}
                            </CountDownV2>
                        ) : null}
                    </View>
                </View>
            </ImageBackground>
        );
    };

    const couponItem = (type = 'large', color = 'red', coupon, needMargin = false) => {
        const renderTag = _coupon => {
            const tag = _coupon?.couponTag?.[0] || 0;
            if (tag === 2 || tag === '2') {
                return $k18n({ id: 'k_1237058' });
            }
            if (tag === 3 || tag === '3') {
                return $k18n({ id: 'k_1237059' });
            }
            if (tag === 4 || tag === '4') {
                return $k18n({ id: 'k_1237060' });
            }
            if (tag === 5 || tag === '5') {
                return $k18n({ id: 'k_1251985' });
            }
            return 'Cupom';
        };

        let bg;
        if (coupon?.discountFeeType === 2) {
            bg = couponBgRedv1;
        } else {
            bg = couponBgBluev1;
        }

        const themeColor = coupon?.discountFeeType === 2 ? '#FF4906' : '#4CA7A2';

        const styleConfig = {
            large: {
                bgWidth: 146,
                bgHeight: 184,
                titleFontSize: 10,
                titleHeight: 36,
                titlePaddingTop: 1,
                conponContentFontSize: 20,
                conponContentHeight: 90,
                conponDescPaddingTop: 12,
                conponDescFontSize: 12,
                claimQuantityFontSize: 12,
            },
            small: {
                bgWidth: scaleW(108),
                bgHeight: scaleW(135),
                titleFontSize: 8,
                titleHeight: 26,
                titlePaddingTop: 2,
                conponContentFontSize: 16,
                conponContentHeight: 66,
                conponDescPaddingTop: 12,
                conponDescFontSize: 9,
                claimQuantityFontSize: 9,
            },
        };

        const itemStyle = styleConfig[type];

        return (
            <ImageBackground
                source={bg} // 图片宽444 高552 宽高比 8/10
                resizeMode="contain" // 这样图片完全被包裹在容器中，容器中可能留有空白 所以容器宽高比要和图片的宽高比一致
                style={[
                    {
                        width: itemStyle.bgWidth,
                        height: itemStyle.bgHeight,
                        position: 'relative',
                        marginBottom: needMargin ? 12 : 0,
                    },
                ]}>
                {/* 券title */}
                <View
                    style={{
                        height: scaleW(itemStyle.titleHeight),
                        paddingTop: itemStyle.titlePaddingTop,
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                    <Text
                        style={{
                            color: themeColor,
                            fontSize: itemStyle.titleFontSize,
                            fontWeight: '500',
                        }}>
                        {renderTag(coupon)}
                    </Text>
                </View>
                {/* 券张数 */}
                {coupon.claimQuantity > 1 ? (
                    <View
                        style={{
                            position: 'absolute',
                            right: type === 'large' ? -6 : -5,
                            top: type === 'large' ? -4 : -3,
                            backgroundColor: '#FFFFFF',
                            borderRadius: 15,
                            borderColor: themeColor,
                            borderWidth: 0.5,
                            borderStyle: 'solid',
                            height: type === 'large' ? 22 : 16,
                            paddingTop: type === 'large' ? 4 : 3,
                            paddingBottom: type === 'large' ? 4 : 3,
                            paddingLeft: type === 'large' ? 6 : 4.5,
                            paddingRight: type === 'large' ? 6 : 4.5,
                        }}>
                        <Text
                            style={{
                                lineHeight: type === 'large' ? 12.5 : 9.5,
                                color: themeColor,
                                fontSize: itemStyle.claimQuantityFontSize,
                            }}>
                            x{coupon.claimQuantity}
                        </Text>
                    </View>
                ) : null}

                {/* 券金额 */}
                <View
                    style={{"position":"relative","top":"0rem"}}>
                    {renderCouponTitle(coupon, itemStyle, themeColor, type)}
                </View>

                {/* 券描述 */}
                <View
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: type === 'large' ? 52 : 38,
                        paddingLeft: 15,
                        paddingRight: 15,
                    }}>
                    <Text
                        numberOfLines={2}
                        ellipsizeMode={'tail'}
                        style={{
                            color: '#FFFFFF',
                            fontSize: itemStyle.conponDescFontSize, // 需要配置
                            fontWeight: '500',
                            textAlign: 'center',
                        }}>
                        {getDescText(coupon)}
                    </Text>
                </View>
            </ImageBackground>
        );
    };

    const handlerRemindLater = () => {
        setRemindLater(!remindLaterFlag);
        remindLaterFlagOriginal = !remindLaterFlag;
    };

    const conponDialogBottomBtn = () => {
        return (
            <View
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    // backgroundColor: 'pink',
                }}>
                {isLogin ? (
                    <TouchableWithoutFeedback
                        onPress={() => {
                            handlerRemindLater();
                        }}>
                        <View
                            style={{"display":"flex","alignItems":"center","justifyContent":"center","flexDirection":"row","borderRadius":"1.4492753623188408rem","paddingTop":"4.830917874396135rem","paddingBottom":"3.8647342995169085rem"}}>
                            <Image
                                source={remindLaterFlag ? couponCheckRaido : couponUncheckRaido}
                                style={{"height":"3.381642512077295rem","width":"3.381642512077295rem","marginRight":"1.4492753623188408rem","marginBottom":"-0.48309178743961356rem"}}
                            />
                            <Text
                                style={{"fontSize":"3.381642512077295rem","color":"#fff"}}>
                                {$k18n({ id: 'k_1251796' })}
                            </Text>
                        </View>
                    </TouchableWithoutFeedback>
                ) : (
                    <View
                        style={{"display":"flex","alignItems":"center","justifyContent":"center","flexDirection":"row","borderRadius":"1.4492753623188408rem","paddingTop":"4.830917874396135rem","paddingBottom":"3.8647342995169085rem"}}>
                        <Text
                            style={{"fontSize":"3.381642512077295rem","color":"#fff"}}>
                            {$k18n({ id: 'k_1318123' })}
                        </Text>
                    </View>
                )}

                <TouchableWithoutFeedback
                    onPress={() => {
                        if (isLogin) {
                            return onClickCloseBtn();
                        }
                        showLoginPop();
                    }}>
                    <View
                        style={{
                            ...padding(13.5, 36, 13.5, 36),
                            backgroundColor: '#FF4906',
                            borderRadius: 100,
                            minWidth: 189,
                        }}>
                        <Text
                            style={{"color":"#FFFFFF","fontSize":"4.347826086956522rem","fontWeight":"700","textAlign":"center"}}>
                            {dialogData?.popupInfo?.actionBtn || $k18n({ id: 'k_1113040' })}
                        </Text>
                    </View>
                </TouchableWithoutFeedback>

                <TouchableWithoutFeedback
                    onPress={() => {
                        onClickCloseBtn();
                    }}>
                    <Image style={{"width":"7.729468599033817rem","height":"7.729468599033817rem","zIndex":100,"marginTop":"0.9661835748792271rem"}} source={pupupClose} />
                </TouchableWithoutFeedback>
            </View>
        );
    };

    const renderCustomIndicator = indicatorProps => {
        const { curIndex = 0, total = 0 } = indicatorProps?.swiperProps || {};
        return (
            <div className="customer-indicator-wrapper">
                {new Array(total).fill(1).map((item, index) => {
                    return <div className={`customer-indicator-item ${curIndex === index ? 'customer-indicator-item-active' : ''}`} key={index} />;
                })}
            </div>
        );
    };

    const renderCoupons = () => {
        const coupons = dialogData?.couponListView;
        if (coupons?.length <= 2) {
            return (
                <View
                    style={{"minWidth":"350px","display":"flex","flexDirection":"row","alignItems":"center","justifyContent":"space-around"}}>
                    {coupons.map(coupon => {
                        return couponItem('large', 'red', coupon, true);
                    })}
                </View>
            );
        }
        if (coupons?.length === 3) {
            return (
                <View
                    style={{"minWidth":"350px","display":"flex","flexDirection":"row","alignItems":"center","justifyContent":"space-around"}}>
                    {coupons.map(coupon => {
                        return couponItem('small', 'red', coupon, true);
                    })}
                </View>
            );
        }
        if (coupons?.length === 4) {
            return (
                <View>
                    <View
                        style={{"width":"250px","display":"flex","flexDirection":"row","alignItems":"center","justifyContent":"space-around"}}>
                        {coupons.slice(0, 2).map(coupon => {
                            return couponItem('small', 'red', coupon, true);
                        })}
                    </View>
                    <View
                        style={{"width":"250px","display":"flex","flexDirection":"row","alignItems":"center","justifyContent":"space-around"}}>
                        {coupons.slice(2, 4).map(coupon => {
                            return couponItem('small', 'red', coupon, true);
                        })}
                    </View>
                </View>
            );
        }
        if (coupons?.length === 5) {
            return (
                <View
                    style={{"display":"flex","justifyContent":"center"}}>
                    <View
                        style={{"display":"flex","minWidth":"350px","flexDirection":"row","alignItems":"center","justifyContent":"space-around"}}>
                        {coupons.slice(0, 3).map(coupon => {
                            return couponItem('small', 'red', coupon, true);
                        })}
                    </View>
                    <div
                        style={{"display":"flex","justifyContent":"center"}}>
                        <div
                            style={{"width":"250px","display":"flex","flexDirection":"row","alignItems":"center","justifyContent":"space-around"}}>
                            {coupons.slice(3, 5).map(coupon => {
                                return couponItem('small', 'red', coupon, true);
                            })}
                        </div>
                    </div>
                </View>
            );
        }
        if (coupons?.length === 6) {
            return (
                <View
                    style={{"minWidth":"350px"}}>
                    <View
                        style={{"display":"flex","flexDirection":"row","alignItems":"center","justifyContent":"space-around"}}>
                        {coupons?.slice(0, 3).map(coupon => {
                            return couponItem('small', 'red', coupon, true);
                        })}
                    </View>
                    <View
                        style={{"display":"flex","flexDirection":"row","alignItems":"center","justifyContent":"space-around"}}>
                        {coupons?.slice(3, 6).map(coupon => {
                            return couponItem('small', 'red', coupon, true);
                        })}
                    </View>
                </View>
            );
        }
        if (coupons?.length > 6) {
            const arr1 = coupons?.slice(0, 6);
            const arr2 = coupons?.slice(6, 12);
            const newArr = [arr1, arr2];
            const renderPage = _coupons => {
                return (
                    <View
                        style={{"marginTop":"3.6231884057971016rem","minWidth":"350px"}}>
                        <View
                            style={{"display":"flex","flexDirection":"row","alignItems":"center","justifyContent":"space-around"}}>
                            {_coupons.slice(0, 3).map(coupon => {
                                return couponItem('small', 'red', coupon, true);
                            })}
                        </View>
                        <View
                            style={{"display":"flex","flexDirection":"row","alignItems":"center","justifyContent":"space-around"}}>
                            {_coupons.slice(3, 6).map(coupon => {
                                return couponItem('small', 'red', coupon, true);
                            })}
                        </View>
                    </View>
                );
            };
            return (
                <View
                    style={{"width":"100rem","display":"flex","justifyContent":"center","alignItems":"center","paddingLeft":"7.246376811594203rem","paddingRight":"7.246376811594203rem"}}>
                    <Swiper
                        autoPlay={false}
                        loop={false}
                        initialIndex={0}
                        renderItem={({ item }) => renderPage(item)}
                        data={newArr}
                        customIndicator={renderCustomIndicator}
                        customStyle={{
                            swiperWidth: '100rem',
                            swiperHeight: scaleW(300),
                        }}
                    />
                </View>
            );
        }
    };

    const renderCouponContainer2 = () => {
        return (
            <View
                style={{"backgroundColor":"rgba(0, 0, 0, 0.72)","display":"flex","flexDirection":"column","alignItems":"center","justifyContent":"center","flex":1,"width":"100%","height":"100vh","position":"fixed","top":"0rem","left":"0rem","zIndex":100}}>
                <View
                    style={{
                        position: 'relative',
                        top: -vh(6),
                    }}>
                    <View
                        style={{"display":"flex","flexDirection":"row","alignItems":"center","justifyContent":"center","marginBottom":"0.9661835748792271rem"}}>
                        {couponDialogTitle()}
                    </View>

                    <div
                        style={{"display":"flex","justifyContent":"center"}}>
                        {renderCoupons()}
                    </div>

                    {conponDialogBottomBtn()}
                </View>
            </View>
        );
    };

    return renderCouponContainer2();
}
